import { TableColumn } from "@components/Table/TableColumns";

export function getCopyTableData(columnsRaw: TableColumn[], rowsCount: number): string[][] {
    // Filter out hidden columns and subColumns
    const columns = columnsRaw
        .filter(column => !column.isHidden && !column.isHiddenForTextMode)
        .map(c => ({
            ...c,
            subColumns: c.subColumns?.filter(subCol => !subCol.isHidden && !subCol.isHiddenForTextMode),
        }));

    // Build the header row aligned with subColumns
    const getSubColumnHeads = (columns: TableColumn[]): string[][] => {
        return columns.map(subCol => subCol.subColumns?.length ? getSubColumnHeads(subCol.subColumns) : subCol.headText ?? '') as unknown as string[][];
    };

    const heads = columns.flatMap((column) => {
        if (column.subColumns) {
            return getSubColumnHeads(column.subColumns).flat(Infinity) as string[];
        }
        // Use empty in case of absent head text to stay consistent with cells count (one cell for a non-group column)
        return [column.headText ?? ''];
    });

    // Determine if we should include a parent header row
    const hasAnyParentHead = columns.some(col => col.subColumns?.length && col.headText !== undefined);

    // Build the parent header row aligned with subColumns
    const parentHeads = hasAnyParentHead
        ? columns.flatMap((column) => {
            if (column.subColumns && column.subColumns.length > 0) {
                const count = column.subColumns.length;
                // Put the parent text in the first cell of the group, blanks for the rest
                const parentHeadRow = Array(count).fill('')
                parentHeadRow[0] = column.headText ?? '';

                return parentHeadRow;
            }

            // For non-group columns, keep a blank placeholder to preserve alignment
            return [''];
        })
        : [];

    const mapColumn = (rowIndex: number) => (column: TableColumn): string | string[] => {
        if (column.subColumns) {
            return column.subColumns.flatMap(mapColumn(rowIndex));
        }

        return column.valueText?.(rowIndex) ?? '';
    }

    const body = Array(rowsCount).fill(0).map((_, rowIndex) =>
        columns.flatMap(mapColumn(rowIndex))
    );

    const copyTableData = [heads, ...body];
    if (hasAnyParentHead) {
        copyTableData.unshift(parentHeads);
    }

    return copyTableData
}